import React, { useEffect, useState } from 'react';
import { debounce } from '../_utils';
import './Typeahead.css';
var Typeahead = function (props) {
    var id = props.id, _a = props.value, value = _a === void 0 ? '' : _a, keyField = props.keyField, formatter = props.formatter, required = props.required, options = props.options, _b = props.delay, delay = _b === void 0 ? 100 : _b, readOnly = props.readOnly, onSelectChange = props.onSelectChange, onSearchChange = props.onSearchChange, className = props.className;
    var format = function (content) {
        return formatter ? formatter(content) : content;
    };
    var _c = useState(format(value)), query = _c[0], setQuery = _c[1];
    var _d = useState(false), showOptions = _d[0], setShowOptions = _d[1];
    useEffect(function () {
        setQuery(readOnly ? '' : format(value));
    }, [readOnly, value]);
    var handleSelectChange = function (id, option, nativeEvent) {
        setShowOptions(false);
        var optionValue = getOptionValue(option);
        setQuery(format(optionValue));
        onSelectChange &&
            onSelectChange({ id: id, value: option }, nativeEvent);
    };
    var handleSearchChange = debounce(function (search, nativeEvent) {
        setQuery(format(search));
        onSearchChange && onSearchChange(search, nativeEvent);
        setShowOptions(true);
    }, delay);
    var getOptionValue = function (option) {
        return keyField ? option[keyField] : option;
    };
    var componentId = id ? id : "OTypeahead_" + keyField;
    return (React.createElement("div", { className: className },
        React.createElement("input", { id: componentId, defaultValue: query, className: "form-control", required: required, readOnly: readOnly, autoComplete: "off", onClick: function () { return setShowOptions(!showOptions); }, onChange: function (nativeEvent) {
                return handleSearchChange(nativeEvent.target.value, nativeEvent);
            } }),
        !!showOptions && (options === null || options === void 0 ? void 0 : options.length) && !readOnly && (React.createElement("ul", { className: "sform-search-dropdown-menu show" }, options.map(function (option, index) {
            var optionValue = getOptionValue(option);
            return (React.createElement("li", { key: index, className: "dropdown-item", role: "option", onClick: function (nativeEvent) {
                    return handleSelectChange(componentId, option, nativeEvent);
                } }, format(optionValue)));
        })))));
};
export default React.memo(Typeahead);
